import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalDirective, ModalModule } from 'ngx-bootstrap/modal';
import { ApiLevelsService } from '../../../../services/levels/api/api-levels.service';
import { AlertsService } from '../../../../services/alerts.service';

@Component({
  selector: 'app-level-add-modal',
  templateUrl: './level-add-modal.component.html',
  standalone: true,
  imports: [ModalModule, CommonModule, FormsModule]
})
export class LevelAddModalComponent {

  @ViewChild('modal') modal!: ModalDirective;

  isLoading: boolean = false;
  level: number = 0;
  nextLevelExperienceRequired: number = 0;
  nextLevelReward: number = 0;

  private callbackSaved?: () => void;

  constructor(private apiLevelsService: ApiLevelsService, private alertsService: AlertsService) {}

  show(callbackSaved?: () => void): void {
    this.callbackSaved = callbackSaved;
    this.level = 0;
    this.nextLevelExperienceRequired = 0;
    this.nextLevelReward = 0;
    this.isLoading = false;
    this.modal.show();
  }

  save(): void {
    this.isLoading = true;
    this.apiLevelsService.addLevel(this.level, this.nextLevelExperienceRequired, this.nextLevelReward).then(
      () => {
        this.isLoading = false;
        this.modal.hide();
        this.alertsService.displayAlertSuccess('Level added !');
        if (this.callbackSaved) { this.callbackSaved(); }
      }, error => {
        this.isLoading = false;
        this.alertsService.displayAlertError('Error adding level : ' + error);
      }
    );
  }
}
